import InvoiceList from "../../components/accounting/InvoiceList";

export default function Billing() {
  return <InvoiceList />;
}
